import {
  DeleteOutline,
  EditOutlined,
  FileCopyOutlined,
} from "@mui/icons-material";
import {
  Box,
  Button,
  ButtonGroup,
  Card,
  CardActionArea,
  CardContent,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import { CampaignState } from "../service/campaigns.types";
import { PUIContentCarousel } from "modules/UI/components/ContentCarousel.component";
import PUIRatioBox from "modules/UI/components/RatioBox.component";
import { useActiveUser } from "modules/User/activeUser";
import { IUserRole } from "modules/User/service/user";

const isPendingState = (state: CampaignState): boolean => {
  return (
    state === CampaignState.Pending_NPD ||
    state === CampaignState.Pending_GlobalQuality ||
    state === CampaignState.Pending_Rejected_NPD ||
    state === CampaignState.Pending_Market_Proc ||
    state === CampaignState.Pending_Rejected_GlobalQuality ||
    state === CampaignState.Pending_Confirm_Price
  );
};

const canEditMaterials = (state: CampaignState): boolean => {
  return (
    state === CampaignState.Draft ||
    (isPendingState(state) &&
      state !== CampaignState.Pending_Confirm_Price &&
      state !== CampaignState.Pending_Market_Proc)
  );
};

export const CampaignMaterialCard = ({
  material,
  campaign,
  requests,
  onRefetch,

  onRemove,
  onDuplicate,
  onEdit,
  onDetails,

  canDelete = false,
  canDuplicate = false,
  canUpdate = false,
}) => {
  const currentUser = useActiveUser();

  return (
    <>
      <Card sx={{ width: "100%" }}>
        <Box sx={{ width: "100%" }}>
          {material.mediaFiles.filter((f) => !f.isQuality).length > 0 ? (
            <PUIContentCarousel
              data={material.mediaFiles
                .filter((f) => !f.isQuality)
                .map((file) => ({
                  type: "image",
                  thumbnail: file.url,
                  src: file.url,
                }))}
            // onPreview={() => {}}
            />
          ) : (
            <PUIRatioBox xRatio={16} yRatio={9}>
              <></>
             
            </PUIRatioBox>
          )}
        </Box>
        <CardContent>
          {material.shortDescription} (#{material.id})
        </CardContent>
       <CardActionArea>
  {canEditMaterials(campaign.state) &&
    (canDelete || canDuplicate || canUpdate) && (

      <Box textAlign={"center"} sx={{ mb: 2 }}>
        <ButtonGroup variant="outlined" color="primary">

          {canDelete && (
            <Tooltip arrow title="Delete material">
              <Button onClick={() => onRemove?.(material)}>
                <DeleteOutline />
              </Button>
            </Tooltip>
          )}

          {canDuplicate && (
            <Tooltip arrow title="Duplicate material">
              <Button onClick={() => onDuplicate?.(material)}>
                <FileCopyOutlined />
              </Button>
            </Tooltip>
          )}

          {canUpdate && (
            <Tooltip arrow title="Edit material">
              <Button onClick={() => onEdit?.(material)}>
                <EditOutlined />
              </Button>
            </Tooltip>
          )}

        </ButtonGroup>
      </Box>
    )}

  {!canEditMaterials(campaign.state) && (
    <Button
      size="large"
      variant="text"
      fullWidth
      onClick={() => {
        onDetails?.(material);
      }}
    >
      Details & Pre-Order
    </Button>
  )}
</CardActionArea>
      </Card>
    </>
  );
};
